import { Colors } from "@/enums/Colors";
import { Button, styled } from "@mui/material";

export const RoundButton = styled(Button)<{
  width?: string;
  height?: string;
  active?: boolean;
  defaultBackgroundColor?: string;
}>(({ height, width, active, defaultBackgroundColor }) => ({
  padding: "0px",
  minWidth: "0px",
  minHeight: "0px",
  cursor: "pointer",
  display: "grid",
  placeItems: "center",
  width: width || "24px",
  height: height || "24px",
  borderRadius: "6.25rem",
  transition: "background-color 0.15s ease-in",
  backgroundColor: active ? Colors.BUTTON_SECONDARY_HOVER_PURPLE : defaultBackgroundColor || "white",
  "&:hover": {
    backgroundColor: Colors.BUTTON_SECONDARY_HOVER_PURPLE,
  },
}));
